const ENContractLimits = {
	"Bloquear excedido alterado com sucesso": "Block exceeded changed successfully",
	"Data de vencimento": "Due date",
	"Erro ao alterar valor": "Error changing value",
	"Monitorar contratos": "Monitor contracts",
	"Ultrapassou": "Exceeded"
};

export default ENContractLimits;
